import { replaceContentDomain as replaceContentDomainByBfe } from '@bfe/by-dynamic-domain';

import { REGULATED_SITE_HOSTS } from './compliance';

export const demoAccountAllowPath = [
  '/app/user/api-management',
  '/app/user/add-secret-key',
  '/app/user/edit-secret-key',
];

const DEFAULT_LANG_BY_SITE = {
  HKG: 'zh-HK',
  NLD: 'nl-NL',
  TUR: 'tr-TUR',
  KAZ: 'kk-KAZ',
};

export const DEFAULT_LANG =
  DEFAULT_LANG_BY_SITE[
    REGULATED_SITE_HOSTS as keyof typeof DEFAULT_LANG_BY_SITE
  ] || 'en';

export const replaceContentDomain =
  window.replaceContentDomain || replaceContentDomainByBfe;

export const TG_PLATFORM = {
  pc_tg: 'pc(Telegram)',
  ios_tg: 'iOS(Telegram)',
  android_tg: 'Android(Telegram)',
};

export const WHITE_HOST = [
  'bybit.com',
  'bybit.kz',
  'bybit.eu',
  'bybit.ae',
  'byhkbit.com',
  'bybit-tr.com',
  'bybit.nl',
  'bybit-global.com',
  'bycloud.org',
  'bybits.org',
  'bybitx.global',
  'bybitglobal.com',
  'bytick.com',
  'bybit.cloud',
  'bybit.global',
  'bybit.org',
  'bybitgum.com',
  'bybitgum.org',
  'bybits.io',
  'bybit.biz',
];

export enum VIP_TYPE {
  NoVip = 1,
  Vip = 2,
  Pro = 3,
}
